import { useMutation, useQueryClient } from '@tanstack/react-query';
import { QUERY_KEYS } from '@/query/queryKeys';
import { reportingService } from '../../services/reportingService';

export const useSubmitReportingDocuments = reportingId => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: payload =>
      reportingService.submitDocuments(reportingId, payload).then(response => {
        const { status, data } = response;
        if (status === 200) {
          queryClient.setQueryData([QUERY_KEYS.reporting.detail, reportingId], () => data);
          return data;
        }
      }),
  });
};
